import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_error/403')({
  component: Page403,
});

function Page403() {
  return (
    <main className='flex flex-col flex-1 justify-center items-center px-6 max-w-xl text-center gap-10 mx-auto'>
      <img src='/403.svg' alt='403 Access Denied' width={288} height={118} />
      <h2 className='font-bold text-3xl'>This page isn't available for your account.</h2>
      <p>
        If you consider you should have access please contact&nbsp;
        <a href='mailto:talentiq@dxc.com' className='text-primary hover:underline'>
          talentiq@dxc.com
        </a>
      </p>
    </main>
  );
}
